import { BankAccountLocation } from '@40seas/entities/bank-account';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const FeeDefinitionWireOptionsSchema = z.object({
    location: EnumSchema(BankAccountLocation),
});

export class FeeDefinitionWireOptions extends FromSchema(FeeDefinitionWireOptionsSchema) {
    location: BankAccountLocation;
}
